import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { handleSessionExchange } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }

    const sessionId = match[1];

    async function doExchange() {
      const success = await handleSessionExchange(sessionId);
      window.history.replaceState(null, "", window.location.pathname);
      if (success) {
        navigate("/", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }

    doExchange();
  }, [navigate, handleSessionExchange]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#007AFF] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/50 text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
